import './base-url.js';